// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: КАРТА ОБЪЯСНЕНИЙ ОБЛАСТИ «ШАПКА И НАВИГАЦИЯ» (handoff-files/ui-help-2026-09-24/spec-topbar-nav.json).
// Здесь — элементы, у которых УЖЕ есть своя подсказка v-wjTooltipFn с кнопками-действиями (способ 2 ядра: строки объяснения ДОПИСЫВАЮТСЯ в их подсказку,
// кнопки остаются; директиву v-uiHelp на них не ставить — она перезаписала бы __wjTipFn): плитка и подпись рейла страниц, заголовок группы рейла, строка стола
// и категория в списке столов. Строители подсказок — utils/tipActions.js (pageTip_fn / pageGroupTip_fn / workspaceTip_fn / categoryTip_fn): берут отсюда
// выбранные поля через uiHelp_rowsHtml(ключ, { state }, поля). Остальные ключи области (74 элемента спецификации) — волна U2 дописывает в этот же файл.
// Тексты и переводы — из спецификации (поведение по коду Page.vue / RailMenu.vue / App.vue / mainStore.pageRail_rows); строки — литералы в t() (словари uk / ru).
import { t, tn } from '@/i18n'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2): tn — число задач в объяснении бейджа

const topbarNav = {
    // плитка страницы в рейле (и её подпись в раскрытом рейле — тот же элемент <a>): состояние current | other (WORKSPACES[стол].active_page)
    'topbar.rail.page': () => ({
        title: t('Page'),
        what: t('A page of this workspace; the highlighted tile is the page you are on. Hover the rail to see all page names (they appear after a short delay).'),   // IE 2026 10 26 / ODOO-345044 (слово Игоря 26.10: «Hover над иконками страниц — не касалось опции; показывались все тайтлы»; задержка — «функционал с задержкой оставь»)
        why: t('Quick switching between the pages of the workspace.'),
        click: t('Opens the page in this tab. Ctrl/Cmd+click or a middle click opens it in a new browser tab.'),
        affects: t('Drag a widget by its title bar onto a tile to move it to that page; the move lives in this tab until you save the widget set of the page.'),
        stored: t('Which pages are shown is your personal choice: if you starred favourite pages in the Pages panel, the rail shows only them and the current page.'),
        setting: 'fe.ux.favoritesRail, fe.ux.tooltipActions, fe.ux.railHoverLabelsDelay, fe.ux.railHoverLabelsDelayMs',   // IE 2026 10 26 / ODOO-345044 (слово Игоря 26.10: «Hover над иконками страниц — не касалось опции; показывались все тайтлы»; задержка — «функционал с задержкой оставь»)
        states: { current: t('This is the page you are on.'), other: t('Click to open this page.') },
    }),
    // IE 2026 09 26 / ODOO-… (замечание Игоря: «+» на новой странице) · p206b: плитка ВРЕМЕННОЙ страницы (плитка «+» рейла: номер вместо названия, записи PAGE ещё нет) —
    // utils/tipActions.js pageTip_fn; состояние current | other, как у обычной плитки
    'topbar.rail.pageTemp': () => ({
        title: t('New page (not saved)'),
        what: t('A new page made with the «+» tile: it exists only in this tab and has no record yet.'),
        why: t('To lay out widgets on a clean page before saving it.'),
        click: t('Opens the page in this tab. Page settings, links, paste and formatting of the tile become available after the page is saved: Commands → Page → «+», «✓» or «Save as new page».'),
        affects: t('Disappears after a reload unless it is saved.'),
        stored: t('Not saved.'),
        states: { current: t('This is the page you are on.'), other: t('Click to open this page.') },
    }),
    // заголовок группы страниц в рейле: состояние collapsed | expanded (Page.vue groupsCollapsed)
    'topbar.rail.group': () => ({
        title: t('Page group'),
        what: t('A group of pages in the rail.'),
        why: t('Keeps the rail short on workspaces with many pages.'),
        click: t('Collapses or expands the group. The group of the page you are on opens automatically.'),
        affects: t('Collapsing only hides the tiles; the pages themselves stay as they are.'),
        stored: t('In this browser, for this workspace. A group marked «Is collapsed» in the Pages list of the workspace starts collapsed for everyone.'),
        states: { collapsed: t('Collapsed — click to show its pages.'), expanded: t('Expanded — click to hide its pages.') },
    }),
    // строка стола в списке столов (☰): состояние current | other
    'topbar.sidebar.workspace': () => ({
        title: t('Workspace'),
        what: t('A workspace you can open; the highlighted one is open now.'),
        click: t('Opens the workspace in this tab and closes the list. Ctrl/Cmd+click or a middle click opens it in a new browser tab.'),
        affects: t('The workspace you leave stays loaded in this tab.'),
        stored: t('Nothing is stored.'),
        setting: 'fe.ux.tooltipActions',
        states: { current: t('This workspace is open now.'), other: t('Click to open this workspace.') },
    }),
    // категория списка столов (заголовок раздела, не кликается)
    'topbar.sidebar.category': () => ({
        title: t('Category'),
        what: t('A section of the workspace list.'),
        click: t('Not clickable.'),
    }),

    // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U2: продолжение области «шапка и навигация»
    // (spec-topbar-nav.json, 74 элемента) — 65 ключей способа 1 (v-uiHelp в AppTopbar.vue / App.vue / RailMenu.vue /
    // pages/Page.vue / components/AltTabSwitcher.vue / components/DatabasePicker.vue / components/FreeWidgetsStrip.vue);
    // 'topbar.rail.pageNew' (способ 2) объясняется в utils/tipActions.js (pageTip_fn) и здесь тоже присутствует, как и
    // остальные ключи; не вошли (см. README-U2.md): rail.num / rail.badge / rail.groupBadge (нет своей подсказки —
    // наследуют плитку/строку группы), alttab.row (список Alt+Tab существует только при зажатом Alt — объяснение
    // строки перекрывало бы выбор).
    // Workspace list button (☰) — src/AppTopbar.vue
    'topbar.menuToggle': (vars = {}, ctx = {}) => ({
        title: t('Workspace list'),
        what: t('Opens the list of workspaces on the left: pinned ones, data (for administrators) and other workspaces you can open.'),
        why: t('To move to another workspace without going back to the start page.'),
        click: t('A click opens the list; while the list is open the same button (its icon shows the panel filled) closes it. With “Open menus on hover” on in the user menu, hovering opens it too (a click right after hovering keeps it open). The list also closes when the mouse leaves it or after you pick a workspace.'),   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл) · IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: иконка панели столов — «panel-left» с состоянием открыто/закрыто; «Страницы» в шапке — глиф вкладок)
        affects: t('Nothing changes until you pick a workspace. Workspaces you have already opened stay loaded in this tab.'),
        stored: t('Nothing is stored.'),
        states: { open: t('The list of workspaces is open — a click closes it.'), closed: t('The list of workspaces is closed — a click opens it.') },   // IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: иконка панели столов — «panel-left» с состоянием открыто/закрыто; «Страницы» в шапке — глиф вкладок)
    }),
    // Workspace name (plain) — src/AppTopbar.vue
    'topbar.title': (vars = {}, ctx = {}) => ({
        title: t('Workspace name'),
        what: t('Name of the workspace open in this tab.'),
        why: t('Shows where you are.'),
        click: t('In this layout the name is not clickable: pages are switched in the pages rail on the left or with the pages button, if it is shown.'),
        setting: 'fe.ux.pagesMenuOnTitle, fe.ux.pagesPanelOnRailToggle, fe.ux.tasksPanelOnTitle',   // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка)
    }),
    // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2 — «при наведении на бэч … и удержании альта надо подробно говорить, что это такое»): красный бейдж с числом у названия стола
    // (форма меню рабочей области на названии) — src/AppTopbar.vue wsTitleBadge; vars: n — число задач, names — их названия (до пяти), readAt — когда прочитаны статусы
    'topbar.tasksBadge': (vars = {}) => {
        const n = +vars.n || 0
        return {
            title: t('Tasks with errors'),
            what: t('The number of tasks of this workspace whose last run ended with an error (loads, calculations, checks from the task tree of the workspace).'),
            why: t('So that you notice a failed load or calculation before relying on the numbers it should have updated.'),
            now: n ? tn(n, '{n} task failed on its last run', '{n} tasks failed on their last run') + (vars.names ? ': ' + vars.names : '') : t('No task failed on its last run'),
            click: t('Click the workspace name and open the Tasks tab: failed tasks are marked with a red Error status. Open a task to see its log and the error, fix the cause and run it again; ↻ on the tab re-reads the statuses.'),
            stored: t('Statuses come from the task log on the server: they are read when the workspace opens and when the Tasks tab opens (if older than a minute).') + (vars.readAt ? ' ' + vars.readAt + '.' : ''),
            setting: 'fe.ux.workspaceMenuOnTitle, fe.ux.menuPanelTasks, fe.ux.tasksPanelAllUsers, fe.ux.tasksBarAutoFetch, fe.data.tasksBarStaleSec',
        }
    },
    // Critical tasks alarm (icon + red stripe) — src/AppTopbar.vue
    'topbar.alarm': (vars = {}, ctx = {}) => ({
        title: t('Critical tasks alarm'),
        what: t('Blinking red sign and a red line along the top of the header: critical tasks of this workspace failed or have been waiting to start too long.'),
        why: t('So that an administrator notices a broken recalculation before users rely on outdated numbers.'),
        click: t('Opens the list of these tasks with the reason (error or waiting), comment and time.'),
        affects: t('The click changes nothing. The sign reflects the server\'s latest check; a check older than 30 minutes is ignored.'),
        stored: t('Computed by the server and kept with the workspace; closing the list is remembered only in this tab.'),
        setting: 'fe.polling.alarmMaxAgeMin',
    }),
    // Alarm reason badge — src/AppTopbar.vue
    'topbar.alarm.badge': (vars = {}, ctx = {}) => ({
        title: t('Reason'),
        what: t('Why the task is in the list: Error — its last run failed; Waiting — it has been waiting to start longer than allowed.'),
        why: t('Helps to decide what to check first.'),
        states: { error: t('Last run failed.'), stuck: t('Waiting to start longer than allowed.') },
    }),
    // Alarm dialog: Continue — src/AppTopbar.vue
    'topbar.alarm.continue': (vars = {}, ctx = {}) => ({
        title: t('Continue'),
        what: t('Closes the alarm list so you can keep working.'),
        click: t('The list will not open by itself again in this tab for this workspace; the red sign stays — click it to see the list again.'),
        affects: t('Tasks are not restarted and nothing is marked as solved.'),
        stored: t('Only in this tab: after a reload the list opens again if the alarm is still active.'),
    }),
    // IE 2026 11 03 / ODOO-350881 (инвентаризация помощи, этап 1): «?» страницы и её рабочей области (header icon, флаг fe.ux.helpCard) — src/AppTopbar.vue
    'topbar.right.helpCardPage': (vars = {}, ctx = {}) => ({
        title: t('About this page'),
        what: t('Opens the help card of the current page; its second tab is about the workspace of the page.'),
        why: t('To find out what the page and the workspace are for and where the user guide tells about them.'),
        click: t('Click — open or close the card.'),
        affects: t('Nothing changes in the data.'),
        stored: t('Nothing is stored.'),
        setting: 'fe.ux.helpCard',
    }),
    // Chats (header icon) — src/AppTopbar.vue
    'topbar.right.globalChats': (vars = {}, ctx = {}) => ({
        title: t('Chats'),
        what: t('Opens the Chats widget on the current page.'),
        why: t('To discuss the data with colleagues without leaving the page.'),
        click: t('Opens the Chats widget or brings it forward.'),
        affects: t('The widget is added to this page in this tab; messages are shared with other users.'),
        stored: t('The widget stays on the page only in this tab unless you save the page\'s widget set.'),
        hotkey: t('Alt K'),
    }),
    // Search (header icon) — src/AppTopbar.vue
    'topbar.right.globalSearch': (vars = {}, ctx = {}) => ({
        title: t('Search'),
        what: t('Full-text search across the records of this database, with filters by collection, segment and status. The References tab shows who refers to an object.'),
        why: t('To find any record by its name or ID and open it.'),
        click: t('Opens or closes the search window.'),
        affects: t('Search only reads data.'),
        stored: t('Nothing is stored.'),
        hotkey: t('F3 — search for the text of the current field or cell; Shift+F3 — who refers to the object in the current cell'),
    }),
    // Recent activities (header icon) — src/AppTopbar.vue
    'topbar.right.globalHistory': (vars = {}, ctx = {}) => ({
        title: t('Recent activities'),
        what: t('Opens the Page widgets list: all widgets open on this page, in the same form as the page settings.'),
        why: t('To see and manage the widgets of the page in one list.'),
        click: t('Opens the list or brings it forward.'),
        affects: t('Changes made in this list apply to the page at once.'),
        stored: t('Only in this tab until you save the page\'s widget set.'),
        setting: 'fe.ux.menuPanelUser',
    }),
    // Log (header icon) — src/AppTopbar.vue
    'topbar.right.globalLog': (vars = {}, ctx = {}) => ({
        title: t('Log'),
        what: t('Opens the log: recent runs and operations with their status and duration, with search.'),
        why: t('To check what ran recently and whether it finished without errors.'),
        click: t('Opens or closes the log window; an entry opens its log record.'),
        affects: t('The log is only read.'),
        stored: t('Nothing is stored.'),
        setting: 'fe.ux.menuPanelUser',
    }),
    // Full screen (header icon) — src/AppTopbar.vue
    'topbar.right.onFullscreen__Click': (vars = {}, ctx = {}) => ({
        title: t('Full screen'),
        what: t('Switches the browser window to full screen and back.'),
        why: t('Gives the widgets more room.'),
        click: t('Toggles full screen for the whole application; menus and panels stay available in it.'),
        affects: t('Only this browser window.'),
        stored: t('Nothing is stored.'),
        hotkey: t('Esc — leave full screen'),
        setting: 'fe.ux.fullscreenOverlays',
    }),
    // More (⋮) — src/AppTopbar.vue
    'topbar.more': (vars = {}, ctx = {}) => ({
        title: t('More'),
        what: t('Appears when the header is too narrow and collects everything that did not fit: icons, the page menus, the database, process model and user menus.'),
        why: t('So that nothing becomes unreachable on a narrow screen.'),
        click: t('Opens a list with the hidden commands; a click outside closes it.'),
        // IE 2026 10 08 / ODOO-5800 (скрины Игоря): пункты «⋮» открывают те же формы, что кнопки широкой шапки (fe.ux.topbarOverflowSameMenus)
        affects: t('Each row of this list opens the same form as the corresponding button of the wide header: the Pages, Page menu, Tasks and User menu panels, the database picker and the process model menu.'),
        stored: t('Nothing is stored.'),
        setting: 'fe.ux.topbarOverflowSameMenus — ' + t('off: the rows of this list open classic drop-down menus instead, as before'),
    }),
    // Database chip — src/AppTopbar.vue
    'topbar.db': (vars = {}, ctx = {}) => ({
        title: vars.name ? t('Database') + ': {name}' : t('Database'),   // IE 2026 11 04 / ODOO-350449 (заказ Игоря: верхняя полоса в один ряд — иконки вместо подписей, «⋯» вместо поиска): в сжатой полосе кнопка — одна иконка, название базы — здесь (vars.name)
        what: t('The database this tab works in.'),
        why: t('Several databases may be available (production, test, demo); the name shows which one you are in.'),
        click: t('Opens the database picker: search, your databases and all available ones, favourites.'),
        affects: t('Picking another database switches this tab to it: the open workspaces of the current database are closed.'),
        stored: t('Favourite databases are saved in your user profile, on all devices.'),
        hotkey: t('Esc — close the picker'),
    }),
    // Process model menu — src/AppTopbar.vue
    'topbar.pm': (vars = {}, ctx = {}) => ({
        title: t('Process model'),
        what: t('The planning model whose data you see. Hover to pick another model or a What-if branch.'),
        why: t('To compare scenarios or look at another version without changing what others see.'),
        click: t('Picking a model re-reads the data for it — on the current page at once, on other pages when you open them; widgets and filters stay in place. Branch commands in the same menu create or discard What-if models in the database.'),
        affects: t('An amber line along the top of the header and an amber icon mean you are not on the database\'s current model.'),
        stored: t('The choice lives in the page address of this tab, not for other users.'),
        states: { current: t('You are on the database\'s current process model.'), notCurrent: t('You are viewing a model other than the database\'s current one — numbers may differ from what colleagues see.') },
    }),
    // Page menus Widgets / Calc / More (classic) — src/AppTopbar.vue
    'topbar.menus.fallback': (vars = {}, ctx = {}) => ({
        title: t('Page menus'),
        what: t('Menus of the current page (Widgets, Calc, More) as drop-down lists.'),
        why: t('The classic form of the page menu: used when the page menu panel is turned off, on phones and inside ⋮ on a narrow header.'),
        click: t('Hover opens a menu; an item opens a widget or runs a command on the current page.'),
        affects: t('Same commands as in the page menu panel.'),
        setting: 'fe.ux.menuPanel, fe.ux.menuPanelPage',
    }),
    // User menu (classic) — src/AppTopbar.vue
    'topbar.user.fallback': (vars = {}, ctx = {}) => ({
        title: t('User menu'),
        what: t('Your menu as a drop-down list: profile, appearance and language, widget commands, defaults, tools and log out.'),
        why: t('The classic form of the user menu: used when the user menu panel is turned off and on phones.'),
        click: t('Hover opens the menu; pick a command.'),
        setting: 'fe.ux.menuPanel, fe.ux.menuPanelUser',
    }),
    // Debug backend: Enable / Disable debug — src/AppTopbar.vue
    'topbar.debug.toggle': (vars = {}, ctx = {}) => ({
        title: t('Backend debug'),
        what: t('Switches the backend container of this database to debug mode and back.'),
        why: t('For developers: to step through the server code.'),
        click: t('The container is recreated, which takes about 1–2 minutes; reopen this window to see the new status.'),
        affects: t('While it restarts, requests of everyone working with this backend fail. It is offered only on a dedicated debug container.'),
        stored: t('On the server, in the container configuration.'),
        states: { on: t('Debug is on for this backend.'), off: t('Debug is off for this backend.') },
    }),
    // Debug backend: copy — src/AppTopbar.vue
    'topbar.debug.copy': (vars = {}, ctx = {}) => ({
        title: t('Copy'),
        what: t('Copies the VS Code link or the SSH tunnel command.'),
        click: t('Copies it to the clipboard.'),
        stored: t('Nothing is stored.'),
    }),
    // Debug backend: Open in VS Code — src/AppTopbar.vue
    'topbar.debug.vscode': (vars = {}, ctx = {}) => ({
        title: t('Open in VS Code'),
        what: t('Opens the backend code of this database in VS Code over SSH.'),
        why: t('For developers.'),
        click: t('Opens a VS Code link; your computer\'s SSH settings are used.'),
    }),
    // Database picker: search — src/components/DatabasePicker.vue
    'topbar.db.search': (vars = {}, ctx = {}) => ({
        title: t('Search databases'),
        what: t('Filters the list by name, ID, company or description.'),
        why: t('To find a database quickly when there are many.'),
        click: t('Type to filter; the list updates as you type.'),
        stored: t('Nothing is stored.'),
    }),
    // Database picker: found / total — src/components/DatabasePicker.vue
    'topbar.db.counter': (vars = {}, ctx = {}) => ({
        title: t('Found / total'),
        what: t('How many databases match the search out of the current list (My or All).'),
    }),
    // Database picker: My — src/components/DatabasePicker.vue
    'topbar.db.scope.my': (vars = {}, ctx = {}) => ({
        title: t('My databases'),
        what: t('Only the databases assigned to you and those you starred.'),
        why: t('To keep the list short.'),
        click: t('Shows only your databases.'),
        stored: t('Not remembered: the picker opens with «My» every time.'),
        states: { on: t('Showing only your databases.'), off: t('Click to show only your databases.') },
    }),
    // Database picker: All — src/components/DatabasePicker.vue
    'topbar.db.scope.all': (vars = {}, ctx = {}) => ({
        title: t('All databases'),
        what: t('All databases available to you.'),
        click: t('Shows all your available databases.'),
        stored: t('Not remembered.'),
        states: { on: t('Showing all available databases.'), off: t('Click to show all available databases.') },
    }),
    // Database picker: admin info — src/components/DatabasePicker.vue
    'topbar.db.adminInfo': (vars = {}, ctx = {}) => ({
        title: t('Databases: admin info'),
        what: t('Table of all databases: server, backend container, repositories and branches, environment, configuration versions and debug status.'),
        why: t('For administrators: to see where each database runs and whether its versions match.'),
        click: t('Opens the table; nothing can be changed there.'),
        stored: t('Nothing is stored.'),
    }),
    // Database picker: company filter chip — src/components/DatabasePicker.vue
    'topbar.db.company': (vars = {}, ctx = {}) => ({
        title: t('Company filter'),
        what: t('Company with the number of its databases.'),
        click: t('Shows only this company\'s databases; a second click removes the filter.'),
        stored: t('Not remembered.'),
        states: { on: t('Only this company is shown.'), off: t('Click to show only this company.') },
    }),
    // Database picker: database row — src/components/DatabasePicker.vue
    'topbar.db.row': (vars = {}, ctx = {}) => ({
        title: t('Database'),
        what: t('A database you can switch to; the one you are in is marked Current.'),
        click: t('Switches this tab to this database; the screen is blocked while it loads.'),
        affects: t('The open workspaces of the current database are closed.'),
        states: { current: t('You are in this database.'), other: t('Click to switch to this database.') },
    }),
    // Database picker: environment badge — src/components/DatabasePicker.vue
    'topbar.db.env': (vars = {}, ctx = {}) => ({
        title: t('Environment'),
        what: t('Kind of the database: Preprod, Demo, Test or Debug. Production databases have no label and a green icon.'),
        why: t('So that you do not enter real data into a test database by mistake, or the other way round.'),
    }),
    // Database picker: favourite star — src/components/DatabasePicker.vue
    'topbar.db.fav': (vars = {}, ctx = {}) => ({
        title: t('Favourite database'),
        what: t('The star adds the database to «My».'),
        why: t('To keep the databases you use at hand.'),
        click: t('Adds the database to «My» or removes it.'),
        stored: t('In your user profile — the same on all devices.'),
        states: { on: t('In «My».'), off: t('Not in «My».') },
    }),
    // New version banner — src/App.vue
    'topbar.updateBanner': (vars = {}, ctx = {}) => ({
        title: t('New version available'),
        what: t('A new version of the application has been published; this tab still runs the previous one.'),
        why: t('An old tab can show problems that are already fixed.'),
        click: t('Use Reload on the banner to update.'),
        affects: t('The banner cannot be hidden; while it is shown, the widget area moves down.'),
        stored: t('Checked every 10 minutes and whenever you return to the tab.'),
        setting: 'fe.polling.versionCheckMs',
    }),
    // New version banner: Reload — src/App.vue
    'topbar.updateBanner.reload': (vars = {}, ctx = {}) => ({
        title: t('Reload'),
        what: t('Reloads this tab with the new version.'),
        click: t('Reloads the page, bypassing the browser cache.'),
        affects: t('Unsaved changes in open widgets are lost — save them first.'),
    }),
    // Page notice — src/App.vue. IE 2026 09 26 / ODOO-… (замечание Игоря: баннер предупреждения стола):
    // компактный жёлтый баннер под шапкой с ✕ (vars.banner — баннер: строки Click / Affects / Setting и текст предупреждения в Now); прежняя полоса
    // во всю ширину (fe.ux.wsAlertBanner = false, мобильный профиль) — без них
    'topbar.pageNotice': (vars = {}, ctx = {}) => ({
        title: t('Page warning'),
        what: t('Warning under the header: the key tasks this page depends on have not been calculated yet.'),
        why: t('The numbers on this page may be incomplete until those tasks finish.'),
        click: vars.banner ? t('The cross on the right hides the warning until the page is reloaded.') : '',
        affects: vars.banner ? t('While the warning is shown, the widget area starts below it; hiding it frees that space.') : '',
        stored: t('Set by the server when the workspace opens.'),
        how: vars.openTask ? t('«Open task» opens the record of the task the warning is about.') : '',   // IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола)
        setting: vars.banner ? ('fe.ux.wsAlertBanner' + (vars.openTask ? ', fe.ux.wsAlertOpenTask' : '')) : '',   // IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола)
        now: vars.text ? '{text}' : '',
    }),
    // Page warning: close (✕) — src/App.vue
    'topbar.pageNotice.close': (vars = {}, ctx = {}) => ({
        title: t('Hide the warning'),
        what: t('Hides the warning.'),
        click: t('The warning stays hidden on every page of this workspace until the page is reloaded; a different warning is shown again.'),
        affects: t('The widget area moves up into the freed space.'),
        stored: t('Only in this browser tab — nothing is saved.'),
        setting: 'fe.ux.wsAlertBanner',
    }),
    // Page warning: Open task — src/App.vue. IE 2026 09 27 / ODOO-… (заказ Игоря: Open task в баннере предупреждения стола): запись задачи,
    // из-за которой висит предупреждение (check-task строки страницы), на текущей странице; vars.many — задач несколько, vars.tasks — их названия
    'topbar.pageNotice.openTask': (vars = {}, ctx = {}) => ({
        title: vars.many ? t('Open tasks') : t('Open task'),
        what: t('Opens the task the warning is about: the task set for this page in the workspace settings that has not finished in the current process model.'),
        why: t('To see why the numbers may be incomplete: the status of the task and its last run.'),
        click: vars.many ? t('Opens the record of each task on the current page; a task already open is brought to the front.') : t('Opens the task record on the current page; if it is already open, brings it to the front.'),
        affects: t('Opening does not start the task and does not hide the warning: the warning goes away once the task has finished and the workspace is opened again.'),
        stored: t('Nothing is saved.'),
        setting: 'fe.ux.wsAlertOpenTask, fe.ux.tasksPanelAllUsers',
        now: vars.tasks ? '{tasks}' : '',
    }),
    // Notification (toast) — src/App.vue
    'topbar.toast': (vars = {}, ctx = {}) => ({
        title: t('Notification'),
        what: t('Message about the result of an action: green — done, yellow — warning or work in progress, red — error.'),
        click: t('Hovering keeps it on screen; otherwise it hides by itself after about 10 seconds. A message about a running calculation stays until it ends.'),
        affects: t('A less important message does not replace a more important one.'),
        stored: t('Nothing is stored.'),
        setting: 'fe.ux.toastTimeoutMs',
        states: { info: t('Information.'), success: t('Done.'), warning: t('Warning.'), pending: t('Work in progress — stays until it ends.'), error: t('Error.'), critical: t('Critical error.') },
    }),
    // Notification: progress bar — src/App.vue
    'topbar.toast.progress': (vars = {}, ctx = {}) => ({
        title: t('Progress'),
        what: t('How far the running calculation has got.'),
    }),
    // Notification: link (e.g. Open log) — src/App.vue
    'topbar.toast.link': (vars = {}, ctx = {}) => ({
        title: t('Open'),
        what: t('Link in the message, for example to the log of the run.'),
        click: t('Closes the message and opens what it refers to.'),
    }),
    // Notification: close — src/App.vue
    'topbar.toast.close': (vars = {}, ctx = {}) => ({
        title: t('Close'),
        what: t('Closes the message.'),
        click: t('A message about a running calculation will not come back until the calculation ends.'),
    }),
    // Test recording indicator — src/App.vue
    'topbar.rec': (vars = {}, ctx = {}) => ({
        title: t('Test recording'),
        what: t('Your actions are being recorded as a test scenario; the counter shows how many steps are recorded.'),
        why: t('To replay the scenario later and compare the results.'),
        stored: t('When stopped, the scenario is saved as a test record in the database.'),
    }),
    // Test recording: Stop — src/App.vue
    'topbar.rec.stop': (vars = {}, ctx = {}) => ({
        title: t('Stop recording'),
        what: t('Stops the test recording.'),
        click: t('Stops recording and saves the scenario.'),
        affects: t('Creates or updates a test record in the database; other users can see it.'),
    }),
    // Cascade debug: Run debug iteration — src/App.vue
    'topbar.cascade.run': (vars = {}, ctx = {}) => ({
        title: t('Run debug iteration'),
        what: t('Runs exactly one step of the recalculation cascade: open the pass, run one stage or finish the pass.'),
        why: t('To follow the recalculation step by step and find where it goes wrong.'),
        click: t('Runs one step; the panel shows what was done and what comes next.'),
        affects: t('Recalculates data in the database for everyone; automatic recalculation stays paused while debug is on.'),
    }),
    // Cascade debug: last step link — src/App.vue
    'topbar.cascade.lastStep': (vars = {}, ctx = {}) => ({
        title: t('Last step'),
        what: t('What the previous step did.'),
        click: t('Opens the log record of this step.'),
    }),
    // Cascade debug: turn off — src/App.vue
    'topbar.cascade.off': (vars = {}, ctx = {}) => ({
        title: t('Turn cascade debug off'),
        what: t('Ends the step-by-step mode.'),
        click: t('Automatic recalculation of the database resumes.'),
        affects: t('Applies to the whole database — for all users.'),
        stored: t('In the database settings.'),
    }),
    // Switching database overlay — src/App.vue
    'topbar.dbSwitching': (vars = {}, ctx = {}) => ({
        title: t('Switching database'),
        what: t('The previous database is already closed; the new one is loading.'),
        why: t('So that you do not keep working thinking you are still in the old database.'),
        click: t('Wait until it loads — the screen is blocked meanwhile.'),
    }),
    // Confirmation with input — src/App.vue
    'topbar.confirm': (vars = {}, ctx = {}) => ({
        title: t('Confirmation'),
        what: t('The command asks you to confirm and enter a value, for example a name.'),
        click: t('Yes (or Enter) runs the command with the entered value; No, Esc or a click outside cancels it.'),
        hotkey: t('Enter — Yes; Esc — No'),
    }),
    // Operation in progress window — src/App.vue
    'topbar.progress': (vars = {}, ctx = {}) => ({
        title: t('Operation in progress'),
        what: t('A long operation is running on the server; the window closes by itself when it ends.'),
    }),
    // New page tile (+) — src/pages/Page.vue
    'topbar.rail.pageNew': (vars = {}, ctx = {}) => ({
        title: t('New page'),
        what: t('Service tile at the end of the rail.'),
        why: t('To lay out widgets on a clean page.'),
        click: t('Creates an empty page named by a number and opens it. Drop a widget onto this tile to move the widget to a new page.'),
        affects: t('The page exists only in this tab and disappears after a reload. The tile is always the last one in the rail — also while the rail shows only favourite pages.'),   // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 1)
        stored: t('Not saved.'),
    }),
    // Hide / show pages rail — src/pages/Page.vue
    // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 3.1–3.2): кнопка вверху рейла (vars.pagesPanel) — клик прячет / показывает рейл, наведение открывает панель страниц
    // IE 2026 10 03 / ODOO-345044 (заказ Игоря: кнопка «Страницы» в шапку, hover-меню с задержкой, скрытие рейки кнопкой в меню): vars.menuRow — последняя строка панели страниц в шапке (кнопка «Страницы» там открывает панель, а прятать рейл — этой строкой)
    'topbar.rail.toggle': (vars = {}, ctx = {}) => vars.menuRow ? ({
        title: t('Hide or show the pages rail'),
        what: t('The last row of the Pages panel: hides the pages rail on the left or brings it back.'),
        why: t('Gives the widgets the full width of the window.'),
        click: t('Hides or shows the rail; the widgets take the freed space at once. While the rail is hidden, move the mouse to the left edge of the window to show it for a moment.') + ' ' + t('The panel stays open after the click.'),
        affects: t('Applies to all workspaces.'),
        stored: t('Only in this browser.'),
        setting: 'fe.ux.pagesButtonInTopbar — ' + t('off: the Pages button returns to the top of the pages rail, where a click on it hides or shows the rail'),
        states: { shown: t('The rail is shown.'), hidden: t('The rail is hidden — use this row to show it, or move the mouse to the left edge to peek.') },
    }) : ({
        title: vars.pagesPanel ? t('Pages rail and pages panel') : t('Hide or show the pages rail'),
        what: vars.pagesPanel ? t('At the top of the pages rail: a click hides the rail or brings it back; hovering it opens the pages panel with all pages of this workspace.') : t('Hides the pages rail on the left or brings it back.'),
        why: t('Gives the widgets the full width of the window.'),
        how: vars.pagesPanel ? t('Hover the button to open the pages panel (search, favourites, the page opened by default); while Alt is held, hovering shows this explanation instead.') : '',
        click: vars.pagesPanel ? t('Hides or shows the rail; the widgets take the freed space at once. While the rail is hidden, the button stays at the top of the left edge as a narrow tab; moving the mouse to the left edge shows the rail for a moment.') : t('Hides or shows the rail; the widgets take the freed space at once. While the rail is hidden, move the mouse to the left edge of the window to show it for a moment.'),
        affects: t('Applies to all workspaces.'),
        stored: t('Only in this browser.'),
        setting: vars.pagesPanel ? 'fe.ux.pagesPanelOnRailToggle — ' + t('off: the button returns to the bottom and the pages panel opens from the workspace name') : '',
        states: { shown: t('The rail is shown.'), hidden: vars.pagesPanel ? t('The rail is hidden — click the tab at the top to show it, or move the mouse to the left edge to peek.') : t('The rail is hidden — move the mouse to the left edge to peek.') },
    }),
    // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p214 єдине меню робочої області — вкладки Меню / Сторінки / Завдання): пункт «All pages…» внизу раскрытого рейла — src/pages/Page.vue
    'topbar.rail.allPages': () => ({
        title: t('All pages…'),
        what: t('Shown under the pages rail while it is expanded by hovering: opens the workspace menu on its Pages tab with all pages of this workspace by groups.'),
        why: t('The rail may show only your favourite pages; the full list, the favourites and the page opened by default are on the Pages tab.'),
        click: t('Opens the workspace menu on the Pages tab next to the rail.'),
        setting: 'fe.ux.railAllPages, fe.ux.workspaceMenuTabs — ' + t('off: no such item, the Pages button is in the top bar'),   // IE 2026 11 03 / ODOO-350610 (rail all pages hidden): пункт показан только при fe.ux.railAllPages = true
    }),
    // Pages rail edge (hot zone) — src/pages/Page.vue
    'topbar.rail.hotzone': (vars = {}, ctx = {}) => ({
        title: t('Pages rail edge'),
        what: t('Invisible strip at the left edge of the window while the pages rail is hidden.'),
        why: t('To reach the pages without turning the rail back on.'),
        click: t('Moving the mouse here shows the rail; it hides again shortly after the mouse leaves it.'),
    }),
    // Pages rail: scroll up — src/pages/Page.vue
    'topbar.rail.scrollUp': (vars = {}, ctx = {}) => ({
        title: t('Scroll pages up'),
        what: t('Shown when the pages do not fit into the height of the window.'),
        click: vars.smooth ? t('Scrolls the rail smoothly by one row; hold the button to keep scrolling. The mouse wheel or touchpad over the rail scrolls it smoothly too.') : t('Scrolls the rail up by one row. The mouse wheel over the rail scrolls it too.'),   // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 2)
        setting: vars.smooth ? 'fe.ux.railSmoothScroll — ' + t('off: the rail scrolls row by row') : '',
        stored: t('The position is kept for this workspace until the tab is reloaded.'),
    }),
    // Pages rail: scroll down — src/pages/Page.vue
    'topbar.rail.scrollDown': (vars = {}, ctx = {}) => ({
        title: t('Scroll pages down'),
        what: t('Shown when more pages are below the visible part of the rail.'),
        click: vars.smooth ? t('Scrolls the rail smoothly by one row; hold the button to keep scrolling. The mouse wheel or touchpad over the rail scrolls it smoothly too.') : t('Scrolls the rail down by one row. The mouse wheel over the rail scrolls it too.'),   // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 2)
        setting: vars.smooth ? 'fe.ux.railSmoothScroll — ' + t('off: the rail scrolls row by row') : '',
        stored: t('The position is kept for this workspace until the tab is reloaded.'),
    }),
    // Workspace list header — src/RailMenu.vue
    'topbar.sidebar.head': (vars = {}, ctx = {}) => ({
        title: t('Workspaces'),
        what: t('The list of workspaces: Home — pinned workspaces (and settings for administrators); Data — catalogs and data (for administrators); Workspaces — other workspaces you can open, including those opened in this session.'),
        why: t('One place to move between workspaces.'),
    }),
    // Workspace list: Close — src/RailMenu.vue
    // IE 2026 10 29 / ODOO-5800 (заказ Игоря 29.10: кнопка «закрыть список столов» на месте кнопки шапки — панель в overlay накрывает шапку)
    'topbar.sidebar.close': (vars = {}, ctx = {}) => ({
        title: t('Close the list'),
        what: t('Closes the workspace list. It stands where the workspace list button of the top bar is, which the open list covers.'),
        why: t('To close the list at the same place where you opened it.'),
        click: t('Closes the workspace list — the same as moving the mouse away from it or pressing the top bar button again.'),
        affects: t('Only this browser window.'),
        stored: t('Nothing is stored.'),
    }),
    // Workspace list: Full screen — src/RailMenu.vue
    'topbar.sidebar.fullscreen': (vars = {}, ctx = {}) => ({
        title: t('Full screen'),
        what: t('Switches the browser window to full screen and back.'),
        why: t('Gives the widgets more room.'),
        click: t('Toggles full screen for the whole application and closes the workspace list.'),
        affects: t('Only this browser window.'),
        stored: t('Nothing is stored.'),
        hotkey: t('Esc — leave full screen'),
        setting: 'fe.ux.fullscreenOverlays',
    }),
    // Workspace list: Log out — src/RailMenu.vue
    'topbar.sidebar.logout': (vars = {}, ctx = {}) => ({
        title: t('Log out'),
        what: t('Ends your session in this database.'),
        click: t('Logs out at once, without asking, and opens the login page.'),
        affects: t('Unsaved changes in open widgets are lost.'),
    }),
    // WebSCM logo — src/RailMenu.vue
    'topbar.sidebar.logo': (vars = {}, ctx = {}) => ({
        title: t('WebSCM'),
        what: t('Link to the webscm.ai website. Its tooltip also shows the versions of the application running in this tab.'),
        click: t('Opens webscm.ai in a new browser tab.'),
    }),
    // Alt+Tab switcher — src/components/AltTabSwitcher.vue
    'topbar.alttab.title': (vars = {}, ctx = {}) => ({
        title: t('Widget switcher'),
        what: t('The list of widgets of this page, opened with Alt+Tab.'),
        why: t('To switch between widgets from the keyboard, like between windows in the operating system.'),
        affects: t('While you move through the list, the selected widget is shown on top; releasing Alt makes it active, Esc returns to the widget you started from.'),
        hotkey: t('Alt+Tab — open; Tab / Shift+Tab — move; release Alt — switch; Esc — cancel. On Windows and Linux the system usually takes Alt+Tab itself; on macOS use Option+Tab'),
        setting: 'fe.ux.altTab, fe.ux.altTabPreview, fe.ux.altTabHistory, fe.ux.altTabOrder, fe.ux.altTabClosed',
    }),
    // Alt+Tab: Docked / Free caption — src/components/AltTabSwitcher.vue
    'topbar.alttab.caption': (vars = {}, ctx = {}) => ({
        title: t('Docked / Free'),
        what: t('Docked — widgets placed in the page grid; Free — floating windows over the page. Each group is listed in screen order.'),
        states: { docked: t('Widgets in the page grid.'), free: t('Floating widgets.') },
    }),
    // Alt+Tab: order number — src/components/AltTabSwitcher.vue
    'topbar.alttab.order': (vars = {}, ctx = {}) => ({
        title: t('Order in history'),
        what: t('Place of the widget on the Tab path: 1 — active now, 2 — the one active before it, and so on.'),
        why: t('A single Alt+Tab takes you back to the previous widget, and the next Alt+Tab brings you back again.'),
        setting: 'fe.ux.altTabHistory',
    }),
    // Alt+Tab: was active mark — src/components/AltTabSwitcher.vue
    'topbar.alttab.mark': (vars = {}, ctx = {}) => ({
        title: t('Was active'),
        what: t('The widget that was active when you opened the list.'),
        click: t('Press Esc to return to it without switching.'),
        hotkey: t('Esc'),
    }),
    // Alt+Tab: closed widget row — src/components/AltTabSwitcher.vue
    'topbar.alttab.closed': (vars = {}, ctx = {}) => ({
        title: t('Closed widget'),
        what: t('A widget of this page that was closed and can still be restored; the newest are first.'),
        why: t('To bring back a widget closed by mistake.'),
        click: t('Only a mouse click reopens it; Tab skips closed widgets.'),
        affects: t('The last closed widget can be restored at any time; earlier ones — for 5 minutes after a newer one is closed.'),
        stored: t('Only in this tab.'),
        hotkey: t('Alt+Esc — reopen the last closed widget'),
        setting: 'fe.ux.altTabClosed',
    }),
    // Alt+Tab: Behavior strip — src/components/AltTabSwitcher.vue
    'topbar.alttab.modes': (vars = {}, ctx = {}) => ({
        title: t('Behavior of free widgets'),
        what: t('What free (floating) widgets do when a docked widget under them becomes active.'),
        why: t('So that floating windows do not hide the widget you are working in.'),
        click: t('Pick a mode — it applies at once. More modes are in the user menu → Widgets → Behavior.'),
        affects: t('All pages in this browser.'),
        stored: t('Only in this browser.'),
        setting: 'fe.ux.freeWidgets',
    }),
    // Behavior: Free widgets in front — src/components/AltTabSwitcher.vue
    'topbar.alttab.mode.stack': (vars = {}, ctx = {}) => ({
        title: t('Free widgets in front'),
        what: t('Default mode: free widgets always stay on top of docked ones.'),
        click: t('Turns this mode on.'),
        affects: t('All pages in this browser.'),
        stored: t('Only in this browser.'),
        setting: 'fe.ux.freeWidgets',
        states: { on: t('This mode is on.'), off: t('Click to turn this mode on.') },
    }),
    // Behavior: Park free widgets — src/components/AltTabSwitcher.vue
    'topbar.alttab.mode.park': (vars = {}, ctx = {}) => ({
        title: t('Park free widgets'),
        what: t('When a docked widget is active, the free widgets covering it are hidden and shown as chips in a strip at the bottom of the screen.'),
        why: t('Keeps the active widget fully visible without closing the floating ones.'),
        click: t('Turns this mode on.'),
        affects: t('All pages in this browser.'),
        stored: t('Only in this browser.'),
        setting: 'fe.ux.freeWidgets',
        states: { on: t('This mode is on.'), off: t('Click to turn this mode on.') },
    }),
    // Alt+Tab: keys hint — src/components/AltTabSwitcher.vue
    'topbar.alttab.hint': (vars = {}, ctx = {}) => ({
        title: t('Keys'),
        what: t('Keyboard hints for the widget switcher.'),
        hotkey: t('Alt+Tab — open; Tab / Shift+Tab — move; release Alt — switch; Esc — cancel. On Windows and Linux the system usually takes Alt+Tab itself; on macOS use Option+Tab'),
    }),
    // Parked widgets strip — src/components/FreeWidgetsStrip.vue
    'topbar.parked': (vars = {}, ctx = {}) => ({
        title: t('Parked widgets'),
        what: t('Free widgets moved out of the way of the active docked widget (Park mode).'),
        why: t('The active widget stays fully visible, and the floating ones are one click away.'),
        affects: t('The strip disappears when a free widget becomes active or another mode is chosen.'),
        stored: t('The mode is kept only in this browser.'),
        setting: 'fe.ux.freeWidgets',
    }),
    // Parked widget chip — src/components/FreeWidgetsStrip.vue
    'topbar.parked.chip': (vars = {}, ctx = {}) => ({
        title: t('Parked widget'),
        what: t('A free widget parked at the bottom of the screen.'),
        click: t('Hover shows the widget on top for a moment; a click brings it back and makes it active.'),
        setting: 'fe.ux.freeWidgets',
    }),
    // Mobile: pages button — src/pages/Page.vue
    'topbar.mobile.pages': (vars = {}, ctx = {}) => ({
        title: t('Pages'),
        what: t('Phone layout: opens the list of pages.'),
        click: t('Tap to open or close the list; a long press restores the last closed widget.'),
    }),
    // Mobile: browse / edit mode — src/pages/Page.vue
    'topbar.mobile.mode': (vars = {}, ctx = {}) => ({
        title: t('Browse or edit mode'),
        what: t('Phone layout: switches all tables between browsing (pan and zoom) and editing (selecting cells).'),
        states: { browse: t('Browsing: pan and zoom.'), edit: t('Editing: select cells.') },
    }),
    // Mobile: widgets button — src/pages/Page.vue
    'topbar.mobile.widgets': (vars = {}, ctx = {}) => ({
        title: t('Widgets'),
        what: t('Phone layout: opens the list of widgets of this page.'),
        click: t('Tap a widget in the list to go to it.'),
    }),
    // Mobile: hide / restore widget — src/pages/Page.vue
    'topbar.mobile.widgetHide': (vars = {}, ctx = {}) => ({
        title: t('Hide or restore widget'),
        what: t('Phone layout: hides the widget or brings a hidden one back.'),
        states: { shown: t('The widget is shown.'), hidden: t('The widget is hidden.') },
    }),
}

export default topbarNav
